import AbstractProvidedClass from "../shared/AbstractProvidedClass";

export default class DropdownSelector extends AbstractProvidedClass {
    _value = null;
    _onChange = null;

    constructor(provider, parent, label, options, iconBuilder) {
        super(provider);
        this._iconBuilder = iconBuilder;
        this._options = options;

        this._container = this.p.createDiv().parent(parent);
        this.p.createElement('h4', label)
            .parent(this._container)
            .class('input-label');

        let wrapper = this.p.createDiv()
            .parent(this._container)
            .class('dropdown-selector');

        let selected = this.p.createDiv()
            .parent(wrapper)
            .class('dropdown-selected');

        this._selectedIcon = document.createElement('div');
        this._selectedIcon.className = 'dropdown-selected-icon';
        selected.elt.appendChild(this._selectedIcon);

        let arrow = document.createElement('div');
        arrow.className = 'dropdown-arrow';
        arrow.innerHTML = '&#9662;';
        selected.elt.appendChild(arrow);

        let dropdown = this.p.createDiv()
            .parent(wrapper)
            .class('dropdown-panel');
        dropdown.hide();

        selected.mouseClicked(() => this._toggle(wrapper, dropdown));

        this._optionEls = [];
        for (let opt of options) {
            let optEl = this.p.createDiv()
                .parent(dropdown)
                .class('dropdown-option')
                .mouseClicked(() => {
                    this._applyValue(opt.value);
                    dropdown.hide();
                    this._onChange?.(opt.value);
                });

            let iconEl = document.createElement('div');
            iconEl.className = 'dropdown-option-icon';
            iconBuilder(iconEl, opt.value);
            optEl.elt.appendChild(iconEl);

            let labelEl = document.createElement('span');
            labelEl.className = 'dropdown-option-label';
            labelEl.textContent = opt.label;
            optEl.elt.appendChild(labelEl);

            this._optionEls.push({ value: opt.value, el: optEl });
        }

        this._applyValue(options[0].value);
        this._container.hide();
    }

    _toggle(wrapper, dropdown) {
        if (dropdown.elt.style.display === 'none') {
            dropdown.show();
            let closeHandler = (e) => {
                if (!wrapper.elt.contains(e.target)) {
                    dropdown.hide();
                    document.removeEventListener('pointerdown', closeHandler);
                }
            };
            setTimeout(() => document.addEventListener('pointerdown', closeHandler), 0);
        } else {
            dropdown.hide();
        }
    }

    _applyValue(val) {
        this._value = val;
        this._selectedIcon.innerHTML = '';
        this._iconBuilder(this._selectedIcon, val);
        this._optionEls.forEach(({ value, el }) => {
            el.elt.classList.toggle('active', value === val);
        });
    }

    get value() {
        return this._value;
    }

    setValue(val) {
        this._applyValue(val);
    }

    setOnChange(fn) {
        this._onChange = fn;
    }

    clearOnChange() {
        this._onChange = null;
    }

    show() {
        this._container.show();
    }

    hide() {
        this._container.hide();
        this._onChange = null;
    }
}
